import React, { Component } from "react";
import axios from "axios";
import * as appConst from "../../../Common/constants";
import DisposeEntry from "./Report.DisposeEntry";

class Dispose extends Component {
  constructor(props) {
    super(props);

    this.state = {
      _id: "",
      name: "",
      date: "",
      desc: "",
      qty: 0,
      receipts: []
    };
  }

  componentDidMount() {
    const ip = {
      count: 1,
      ids: this.props.data
    };

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/equipment/disposeDetails/",
        ip
      )
      .then(response => {
        var obj = response.data;
        var arr = obj.txnDate.split("-");

        const data = {
          _id: obj._id,
          name: obj.name,
          date: arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0],
          qty: obj.qty,
          desc: obj.desc
        };

        this.setState({ receipts: data });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    return <div className="p-5">{this.RenderReceipt()}</div>;
  }

  RenderReceipt() {
    return (
      <DisposeEntry key={this.state.receipts._id} data={this.state.receipts} />
    );
  }
}

export default Dispose;
